export default {
  aa: 'Aa',
  pdf: 'PDF',
  text: 'Texte',
  changePDF: 'Changer le PDF',
  chatGpt: 'Résumé IA'
}
